import { v4 as uuid } from 'uuid'

export const getId = (
  precachedId?: string,
  cachedIds?: Record<string, string>
) => {
  let nodeId: string
  if (precachedId && cachedIds) {
    if (Object.hasOwn(cachedIds, precachedId)) {
      nodeId = cachedIds[precachedId]
    } else {
      nodeId = uuid()
      cachedIds[precachedId] = nodeId
    }
  } else {
    nodeId = uuid()
  }
  return nodeId
}
